import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addAccessManagementUsers,
  deleteAccessManagementUsers,
  editAccessManagementUsers,
  getAccessManagementUsers,
  changePasswordAccessManagementUsers,
} from "store/services/membersAndRoles/teamMembers";
import { uploadFile } from "store/services/utilities";
import { closeAdminModal } from "store/slices/common/adminModal.slice";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

//Get Access Management Users
export const GetAllAccessManagementUsers = createAsyncThunk(
  "access/getAllAccessManagementUsers",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getAccessManagementUsers(payload);

      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      //     dispatch(handleAuthError({status: error?.response?.status}));
      return rejectWithValue(error);
    }
  }
);

//Add Access Management Users
export const AddAccessManagementUsers = createAsyncThunk(
  "access/addAccessManagementUsers",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      let { file, onSuccess, ...rest } = payload;
      if (file) {
        const uploadFilesResponse = await uploadFile({
          file: file,
          uploadFor: "image",
        });
        if (uploadFilesResponse.status === 0) {
          dispatch(
            openToast({ type: "error", message: uploadFilesResponse?.message })
          );
          return rejectWithValue(uploadFilesResponse);
        }
        rest.image = uploadFilesResponse.response.urls[0];
      }
      const res = await addAccessManagementUsers(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        dispatch(closeAdminModal());
        if (onSuccess) {
          onSuccess();
        }

        return fulfillWithValue(res);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) })
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        })
      );
      return rejectWithValue(error);
    }
  }
);

//Add Access Management Users
export const EditAccessManagementUsers = createAsyncThunk(
  "access/editAccessManagementUsers",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { file, onSuccess, ...rest } = payload;
      if (file) {
        const uploadFilesResponse = await uploadFile({
          file: file,
          uploadFor: "image",
        });
        if (uploadFilesResponse.status === 0) {
          dispatch(
            openToast({ type: "error", message: uploadFilesResponse?.message })
          );
          return rejectWithValue(uploadFilesResponse);
        }
        rest.image = uploadFilesResponse.response.urls[0];
      }
      const res = await editAccessManagementUsers(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        dispatch(closeAdminModal());
        if (onSuccess) {
          onSuccess();
        }

        return fulfillWithValue(res);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) })
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        })
      );
      return rejectWithValue(error);
    }
  }
);

//Delete Access Management Users
export const DeleteAccessManagementUsers = createAsyncThunk(
  "access/deleteAccessManagementUsers",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { filter, ...rest } = payload;
      const res = await deleteAccessManagementUsers(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        const responce = await getAccessManagementUsers(filter);
        if (responce.status === 1) {
          return fulfillWithValue(responce);
        }
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) })
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        })
      );
      return rejectWithValue(error);
    }
  }
);

//ChangePassword

export const ChangePasswordAccessManagementUsers = createAsyncThunk(
  "access/changePassword",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const res = await changePasswordAccessManagementUsers(payload);
      if (res.status === 1) {
        dispatch(closeAdminModal());
        return fulfillWithValue({ ...res, ...payload });
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) })
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        })
      );
      return rejectWithValue(error);
    }
  }
);
